<script>
import MyCustomComp from '../src/components/MyCustomComp.vue';
import now from 'lodash-es/now';
import pick from 'lodash-es/pick';

const SFC782dc9aa = function () {
  var render = function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm._m(0);
  };

  var staticRenderFns = [function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', [_c('h3', [_vm._v("Hello World")]), _vm._v(" "), _c('h4', [_vm._v("This is a Static template")])]);
  }];
  return {
    render,
    staticRenderFns
  };
}();

const SFC67a11442 = function () {
  var render = function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "vue-sfc-container"
    }, [_c('p', [_vm._v("This is a embedded Vue SFC: ")]), _vm._v(" "), _c('p', [_vm._v("Last Opt: "), _c('strong', [_vm._v(_vm._s(_vm.lastOptInfo))])]), _vm._v(" "), _c('p', [_vm._v("\n    Counter: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.count,
        expression: "count"
      }],
      attrs: {
        "type": "number",
        "placeholder": "input count",
        "readonly": ""
      },
      domProps: {
        "value": _vm.count
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.count = $event.target.value;
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function ($event) {
          _vm.count++;
        }
      }
    }, [_vm._v("+")]), _c('button', {
      on: {
        "click": function ($event) {
          _vm.count = Math.max(0, _vm.count - 1);
        }
      }
    }, [_vm._v("-")])])]);
  };

  var staticRenderFns = [];
  const componentOptions = {
    name: 'VueSFCContainer',

    data() {
      return {
        count: 0
      };
    },

    computed: {
      lastOptInfo() {
        return `At ${now()}, count is ${this.count}`;
      }

    }
  };
  return { ...componentOptions,
    render,
    staticRenderFns
  };
}();

const UserDefinedCompName = function () {
  var render = function () {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('section', {
      staticClass: "pick-demo"
    }, [_c('h3', [_vm._v("Stylus Decorated: ")]), _vm._v(" "), _c('p', [_vm._v("pickedObject: " + _vm._s(JSON.stringify(_vm.pickedObj)))])]);
  };

  var staticRenderFns = [];
  const componentOptions = {
    data() {
      return {
        obj: {
          prop1: 'value of property 1',
          prop2: 'value of property 2',
          prop3: 'value of property 3'
        }
      };
    },

    computed: {
      pickedObj() {
        return pick(this.obj, ['prop2', 'prop3']);
      }

    }
  };
  return { ...componentOptions,
    render,
    staticRenderFns
  };
}();

export default {
  name: 'Container1b2309d0',
  components: {
    MyCustomComp: MyCustomComp,
    SFC782dc9aa: SFC782dc9aa,
    SFC67a11442: SFC67a11442,
    UserDefinedCompName: UserDefinedCompName
  },
  frontmatter: JSON.parse('{"componentName":"Container1b2309d0"}')
};
</script>

<template>
  <div>
    <h2 style="color: DarkViolet;">Vue SFC Container</h2>
<p>Remember to open your <strong><a href="https://github.com/vuejs/vue-devtools">Vue devtools</a></strong> and check out the demo below:</p>
<p>frontmatter: {{ $options.frontmatter }}</p>
<SFC782dc9aa />
<SFC67a11442 />
<UserDefinedCompName />
  </div>
</template>

<style lang="css">
.vue-sfc-container {
  margin-top: 1em;
}

.vue-sfc-container > p {
  font-weight: bold;
}

.vue-sfc-container span {
  font-weight: normal;
}
</style>
<style lang="stylus">
.pick-demo
  color: DeepPink;
</style>

